import React, { useState, useEffect } from "react";
import Tree from "react-d3-tree";
import { useHistory } from "react-router-dom";
import GenealogyService from "../../../service/tree/genealogy";
import Spinner from "../../shared/Spinner";
import nophoto from "../../../assets/images/nophoto/no_photo.jpg";
import arrowImage from "../../../assets/icons/down_arrow.png";
import SearchContent from "../../components/network/SearchContent";
import Helmet from "react-helmet";
import PageTitle from "../../components/common/pageTitle";
import companyName from "../../../store/mobxStore/companyName";
import { useTranslation } from "react-i18next";
import { Alert } from "react-bootstrap";
import { useSelector } from "react-redux";
import { BASE_URL } from "../../../configuration/apiconfig";

const containerStyles = {
  width: "100vw",
  height: "100vh",
};

const App = () => {
  const [state, setState] = useState({
    loading: false,
    data: null,
    tooltipConfig: {},
    storeUrl: "",
    nodeDatum: null,
    value: false,
    username: "",
    error: {
      show: false,
      message: "",
    },
  });
  const [expandedNodes, setExpandedNodes] = useState({});
  const history = useHistory();
  const service = new GenealogyService();
  const { t } = useTranslation();
  const username = useSelector((state) => state.ProjectConfig.userName);

  useEffect(() => {
    getList(username);
  }, [username]);

  useEffect(() => {
    if (state.data) {
      // Mark all nodes as expanded initially
      const initialExpandedState = {};
      const markAllExpanded = (node) => {
        initialExpandedState[node.attributes.user_id] = true;
        if (node.children) {
          node.children.forEach(markAllExpanded);
        }
      };
      markAllExpanded(state.data);
      setExpandedNodes(initialExpandedState);
    }
  }, [state.data]);

  const getList = (username = "", parentId = "") => {
    setState((prev) => ({ ...prev, loading: true }));
    if (BASE_URL == "http://20.205.159.50:5000/api/web/") {
      service.getSponsorTree2(username, parentId).then((res) => {
        if (res.status) {
          setState((prevState) => ({
            ...prevState,
            loading: false,
            data: res.data,
            tooltipConfig: res.data.tooltip_config,
            storeUrl: res.data.store_url,
          }));
        } else {
          handleErrors(res.error?.code);
        }
      });
    } else {
      service.getSponsorTree3(username, parentId).then((res) => {
        if (res.status) {
          setState((prevState) => ({
            ...prevState,
            loading: false,
            data: res.data,
            tooltipConfig: res.data.tooltip_config,
            storeUrl: res.data.store_url,
          }));
        } else {
          handleErrors(res.error?.code);
        }
      });
    }
  };

  const handleNodeClick = (nodeDatum) => {
    nodeDatum.isLoader = true;
    if (BASE_URL == "http://20.205.159.50:5000/api/web/") {
      service.getSponsorTree2(nodeDatum.attributes.user_name).then((res) => {
        if (res.status) {
          nodeDatum.isLoader = false;
          updateChildTreeData(state.data, nodeDatum, res.data);
          // Mark the node as expanded after loading its children
          setExpandedNodes((prev) => ({
            ...prev,
            [nodeDatum.attributes.user_id]: true,
          }));
        } else {
          handleErrors(res.error?.code);
        }
      });
    } else {
      service.getSponsorTree3(nodeDatum.attributes.user_name).then((res) => {
        if (res.status) {
          nodeDatum.isLoader = false;
          updateChildTreeData(state.data, nodeDatum, res.data);
          // Mark the node as expanded after loading its children
          setExpandedNodes((prev) => ({
            ...prev,
            [nodeDatum.attributes.user_id]: true,
          }));
        } else {
          handleErrors(res.error?.code);
        }
      });
    }
  };

  const updateChildTreeData = (orgChartJson, nodeDatum, extraData) => {
    const updatedData = { ...orgChartJson };
    findAndUpdateNode(updatedData, nodeDatum, extraData);
    setState((prev) => ({
      ...prev,
      data: updatedData,
      loading: false,
    }));
  };

  const findAndUpdateNode = (orgChartJson, nodeDatum, extraData) => {
    if (orgChartJson.children) {
      orgChartJson.children.forEach((element) => {
        if (element.attributes.user_id === nodeDatum.attributes.sponsor_id) {
          const index = element.children.findIndex(
            (obj) => obj.name === nodeDatum.name
          );
          element.children.splice(index, 1, extraData);
        } else {
          findAndUpdateNode(element, nodeDatum, extraData);
        }
      });
    }
  };

  const handleErrors = (errorCode) => {
    if (errorCode === 1002) {
      history.push("/logout");
    } else if (errorCode === 1043) {
      setState((prev) => ({
        ...prev,
        error: {
          show: true,
          message: "InvalidUserName",
        },
      }));
      history.push("/sponsorTree");
    }
  };

  const tooltipHandler = (nodeDatum, value) => {
    const x = window.event.clientX;
    const y = window.event.clientY;

    setState((prevState) => ({
      ...prevState,
      xaxis: x,
      yaxis: y,
      nodeDatum: nodeDatum,
      value: value,
    }));
  };

  const renderNodeWithCustomEvents = ({ nodeDatum, toggleNode }) => {
    const hasSponsoredChildren = nodeDatum.attributes.sponsorOrNot > 0;
    const isExpanded = expandedNodes[nodeDatum.attributes.user_id];
    const hasLoadedChildren =
      nodeDatum.children && nodeDatum.children.length > 0;

    // Show arrow when the node has potential children (sponsorOrNot > 0) and is not expanded
    // or when it's expanded but has no loaded children yet
    const shouldShowArrow =
      hasSponsoredChildren && (!isExpanded || !hasLoadedChildren);

    const handleToggle = () => {
      if (hasSponsoredChildren && !hasLoadedChildren) {
        handleNodeClick(nodeDatum);
      } else {
        toggleNode();
        setExpandedNodes((prev) => ({
          ...prev,
          [nodeDatum.attributes.user_id]: !prev[nodeDatum.attributes.user_id],
        }));
      }
    };

    return (
      <g>
        <image
          x="-30"
          y="-25"
          style={{ width: "60px", height: "60px" }}
          href={nodeDatum.attributes.photo || nophoto}
          clipPath="circle(50.0% at 50% 50%)"
          onMouseOver={() => tooltipHandler(nodeDatum, true)}
          onMouseOut={() => tooltipHandler(nodeDatum, false)}
          alt="User Photo"
          onClick={handleToggle}
        />

        {shouldShowArrow && (
          <image
            x="-10"
            y="70"
            width="25"
            height="25"
            href={arrowImage}
            alt="Toggle Arrow"
            onClick={handleToggle}
          />
        )}

        <text
          fill="black"
          strokeWidth="1"
          x="0"
          y="55"
          dominantBaseline="middle"
          textAnchor="middle"
          onClick={handleToggle}
        >
          {nodeDatum.name}
        </text>
      </g>
    );
  };

  const searchClick = (e) => {
    e.preventDefault();
    if (state.username) {
      getList(state.username);
    }
  };

  const handleChange = (e) => {
    const { value } = e.target;
    setState((prev) => ({
      ...prev,
      username: value,
    }));
  };

  const navigateToUnilevelListing = () => {
    history.push({
      pathname: "/unilevelListing",
      state: { prevPath: history.location.pathname },
    });
  };

  const resetButtonClick = () => {
    setState((prev) => ({
      ...prev,
      error: {
        show: false,
        message: "",
      },
    }));
    history.push("/unilevelTree");
    getList(username);
  };

  return (
    <div>
      <Helmet>
        <title>
          {companyName.companyName} | {t("Sidemenu.sponsorTree")}
        </title>
      </Helmet>
      <PageTitle title="sponsorTree" buttonOn={false} />
      {state.error.show && (
        <Alert
          style={{ top: "5px" }}
          variant="danger"
          onClose={() =>
            setState((prev) => ({
              ...prev,
              error: {
                show: false,
                message: "",
              },
            }))
          }
          dismissible
        >
          {t("validation." + state.error.message)}
        </Alert>
      )}
      {state.loading ? (
        <Spinner />
      ) : (
        <div style={containerStyles}>
          {state.data && (
            <Tree
              data={state.data}
              orientation="vertical"
              translate={{ x: 50, y: 50 }}
              pathFunc="step"
              nodeSize={{ x: 150, y: 150 }}
              renderCustomNodeElement={(rd3tProps) =>
                renderNodeWithCustomEvents(rd3tProps)
              }
            />
          )}
        </div>
      )}
      <SearchContent
        searchClick={searchClick}
        changeHandler={handleChange}
        buttonClick={navigateToUnilevelListing}
        buttonLabel="referralMembers"
        reset={resetButtonClick}
        {...state}
      />
    </div>
  );
};

export default App;
